<div class="card-body">
      <div
        *ngIf="isUserLoggedIn; else notLoggedIn"
        id="showcaseTalkjsContainer"
        class="card-body"
      >
        <div>
          <div id="talkjs-container-desktop" style="width: 100%; height: 670px"></div>
        </div>
      </div>
  
  </div>
  
  <ng-template #notLoggedIn>
    Please <span class="router-link" (click)="onUserNotLoggedIn()" >Log in</span> to access the chat.
  </ng-template>
